export const getVolcengineApiKey = (): string => {
  const key = (import.meta as any).env?.VITE_VOLCENGINE_API_KEY || '';
  return key || '';
};

export const getSeedreamModelId = (): string => {
  const model = (import.meta as any).env?.VITE_SEEDREAM_MODEL_ID || 'doubao-seedream-4-0-250828';
  return model;
};
